import {
    get,
    post,
    Delete,
    formDataPost,
    axios
} from "../ApiDecorator"; // 倒入 api

const Paired = {
    // 获取全部结对空间
    getListByProject(data) {
        return get("/course/spx/listByProject", data);
    },
    // 获取我的结对空间
    getListByOwner(data) {
        return get("/course/spx/listByOwner", data);
    },
    // 空间管理-课表列表（spaceIds 数组：spaceIds=1&spaceIds=2）
    getCourseList(data) {
        return get("/learn/spx/schedule/scheduleRowsBySpaceIds", data);
    },
    // 空间管理-导出 Word 压缩包（blob）
    exportCourseList(data) {
        const params = { ...data, noCache: new Date().getTime() }
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
        return axios.get(`/learn/spx/schedule/exportScheduleWordZip?${query}`, {
            responseType: 'blob',
        }).then(res => res.data)
    },

    // —— 子空间公共 ——
    // 分页查询子空间（结对班级 / 研伴）
    getChildrenPage(data) {
        return get("/course/spx/children/page", data);
    },
    // Excel 批量导入结对班级空间 / 研伴空间
    batchImport(data) {
        return formDataPost("/course/spx/batchImport", data);
    },

    // —— 结对班级空间 ——
    createSpxClass(data) {
        return post("/course/spx-class/createSpxClass", data);
    },
    updateSpxClass(data) {
        return post("/course/spx-class/updateSpxClass", data);
    },
    deleteSpxClass(data) {
        return Delete("/course/spx-class/deleteSpxClass", data);
    },
    getClassesBySchools(data) {
        return get("/course/spx-class/classesBySchools", data);
    },
    pageSpxClassByParent(data) {
        return get("/course/spx-class/pageByParent", data);
    },

    // —— 研伴空间 ——
    createSpxPartner(data) {
        return post("/course/spx-partner/create", data);
    },
    updateSpxPartner(data) {
        return post("/course/spx-partner/updateSpxPartner", data);
    },
    deleteSpxPartner(data) {
        return Delete("/course/spx-partner/deleteSpxPartner", data);
    },
    getPartnerUserOptions(data) {
        return get("/course/spx-partner/userOptions", data);
    },
    getPartnerList(data) {
        return get("/course/spx-partner/list", data);
    },
    // 当前登录人是否为研伴负责人
    isPartnerLeader(data) {
        return get("/course/spx-partner/isLeader", data);
    },
    // 当前登录用户担任学科负责人的研伴空间（id + 名称）
    getPartnerLeaderSpaces(data) {
        return get("/course/spx-partner/leaderSpaces", data);
    },
    // 学科负责人名下研伴空间总结分页列表
    getPartnerSummaryLeaderList(data) {
        return get("/course/spx-partner/summary/leaderList", data);
    },
    // 研伴空间总结详情（含正文与附件）
    getPartnerSummaryDetail(data) {
        return get("/course/spx-partner/summary/detail", data);
    },
    // 学科负责人评价研伴空间总结（覆盖更新；空白则清空）
    evaluatePartnerSummary(data) {
        return post("/course/spx-partner/summary/evaluate", data);
    },
}

export default Paired
